import notifications from '@sigma-frontend-libs/messages/es/notifications'
import sendings from '@sigma-frontend-libs/messages/ru/sendings'

export default {
  titles: {
    variables: 'Variables'
  },

  labels: {
    notification: 'Notificación',
    subject: 'Asunto',
    body: 'Cuerpo de la plantilla',
    channel: 'Canal',
    owner: 'Destinatario',
    targetUser: 'Destinatario',
    type: 'Tipo',
    text: 'Texto',
    sentAt: 'Enviado a las',
    isRead: 'Estado'
  },

  hints: {
    variables: 'Consulte la documentación para obtener más información sobre cómo completar correctamente las plantillas y utilizar variables.'
  },

  channels: sendings.types,
  events: notifications.types,
  childrenUsersEvents: notifications.types,

  email: {
    smtp: {
      host: 'Host',
      port: 'Puerto',
      from: 'Desde',
      login: 'Nombre de usuario',
      password: 'Contraseña'
    },

    templates: notifications.types
  },

  sms: {
    sendername: 'Nombre del remitente',
    senderUserId: 'Remitente',
    templates: notifications.types
  },

  web: { templates: notifications.types },
  push: { templates: notifications.types },
  tgBot: { templates: notifications.types },

  snackbars: {
    updated: 'Configuración actualizada con éxito.'
  },

  isRead: {
    true: 'Leído',
    false: 'No leído',
    sent: 'Enviado: {date}',
    delivered: 'Entregado: {date}'
  },

  tooltips: {
    channel: {
      on: 'Activado',
      off: 'Desactivado'
    }
  }
}
